import {ActionList} from '@primer/react'
import type {Topic} from '../../types/blackbird-types'
import {HashIcon, LinkIcon, RepoIcon} from '@primer/octicons-react'
import {topicPath} from '@github-ui/paths'
import {GitHubAvatar} from '@github-ui/github-avatar'
import styles from './FeaturedTopic.module.css'

function FeaturedTopic({topic, linkedTopic}: {topic: Topic; linkedTopic: string}) {
  const {name, display_name, short_description, github_url, logo_url, development_logo_url, url, wikipedia_url} = topic
  // eslint-disable-next-line no-restricted-syntax
  const nwo = github_url ? new URL(github_url).pathname.substring(1) : null
  // eslint-disable-next-line no-restricted-syntax
  const urlHost = url ? new URL(url).hostname.replace('www.', '') : null
  const topicUrl = topicPath({topicName: linkedTopic})
  const logo = development_logo_url || logo_url
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        {logo && <GitHubAvatar alt={linkedTopic} src={logo} size={24} square className={styles.avatar} />}
        <span className={styles.topicName}>{display_name ?? name}</span>
      </div>
      <div className={styles.descriptionWrapper}>
        <span className={styles.description}>{short_description}</span>
      </div>

      <ActionList>
        {url && (
          <ActionList.LinkItem href={url} className={styles.accentLink}>
            <ActionList.LeadingVisual>
              <LinkIcon />
            </ActionList.LeadingVisual>
            {urlHost}
          </ActionList.LinkItem>
        )}

        {wikipedia_url && (
          <ActionList.LinkItem href={wikipedia_url} className={styles.accentLink}>
            <ActionList.LeadingVisual>
              <LinkIcon />
            </ActionList.LeadingVisual>
            Wikipedia
          </ActionList.LinkItem>
        )}

        {github_url && (
          <ActionList.LinkItem href={github_url} className={styles.mutedLink}>
            <ActionList.LeadingVisual>
              <RepoIcon />
            </ActionList.LeadingVisual>
            {nwo}
          </ActionList.LinkItem>
        )}
        <ActionList.LinkItem href={topicUrl} className={styles.mutedLink}>
          <ActionList.LeadingVisual>
            <HashIcon />
          </ActionList.LeadingVisual>
          View topic
        </ActionList.LinkItem>
      </ActionList>
    </div>
  )
}

export default FeaturedTopic
